<sharry-header></sharry-header>
<div class="community">
  <ng-container
    [ngTemplateOutlet]="community"
    [ngTemplateOutletContext]="{ $implicit: userService.user$ | async }"></ng-container>
</div>
<ng-template
  #community
  let-user
  [typeToken]="typeToken">
  <!--  @if (showHero) {
    <sharry-hero
      component="community"
      [backGroundImages]="heroImages"
      [shortHero]="true">
    </sharry-hero>
  }-->
  <section class="community__grid">
    <aside>
      <div>
        @if (!!user) {
          <div class="community__additional-info">
            <p class="community__additional-info__title semibold bigger">{{ 'community.followers' | i18next }}</p>
            @if (followers$ | async; as followers) {
              @if (!!followers?.followers?.length) {
                <div class="cursor-pointer">
                  <sharry-people-avatar-list
                    [users]="followers.followers"
                    [count]="followers.followersCount"
                    [maxLength]="6"
                    (peopleClicked)="
                      !followerBusy && onFollowersClick(); $event.stopPropagation(); $event.preventDefault()
                    "></sharry-people-avatar-list>
                </div>
              } @else {
                <p>{{ 'community.follower.empty' | i18next }}</p>
              }
              <button
                class="sharry-simple"
                (click)="onShare()">
                {{ 'community.share.button' | i18next }}
                <sharry-icon
                  registryName="caret-right"
                  class="svg-icon caret"></sharry-icon>
              </button>
            }
          </div>
        }
        @if (!!user) {
          <div class="community__additional-info">
            <p class="community__additional-info__title semibold bigger">{{ 'community.followings' | i18next }}</p>
            @if (followings$ | async; as followings) {
              @if (!!followings.followings.length) {
                <div class="cursor-pointer">
                  <sharry-people-avatar-list
                    [users]="followings.followings"
                    [count]="followings.followingsCount"
                    [maxLength]="6"
                    (peopleClicked)="
                      !followingBusy && onFollowingsClick(); $event.stopPropagation(); $event.preventDefault()
                    "></sharry-people-avatar-list>
                </div>
              } @else {
                <p>{{ 'community.following.empty' | i18next }}</p>
              }
              <button
                class="sharry-simple"
                (click)="onUserSearch()">
                {{ 'community.followings.button' | i18next }}
                <sharry-icon
                  registryName="caret-right"
                  class="svg-icon caret"></sharry-icon>
              </button>
            }
          </div>
        }
        <div class="community__additional-info">
          <ng-container *appShellNoRender>
            @if (!userService?.user) {
              <sharry-signup-box></sharry-signup-box>
            }
          </ng-container>
          <p class="community__additional-info__title semibold bigger">
            {{ 'community.recommendedProfiles' | i18next }}
          </p>
          @for (profile of recommendedProfiles$ | async; track profile.id) {
            <a
              class="community__additional-info__record"
              [routerLink]="profile | slug">
              <div [avatar]="{ user: profile, size: 'small', imgSize: '44px' }"></div>
              <div>
                <small
                  class="bold"
                  [innerHTML]="profile | colorize: 'short'"></small>
                <p class="semibold">{{ profile | userName }}</p>
              </div>
            </a>
          }
        </div>
      </div>
    </aside>
    <article class="community__feed">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </article>
    <aside>
      <div>
        <div class="community__additional-info">
          <p class="community__additional-info__title semibold bigger">{{ 'community.hastags' | i18next }}</p>
          @for (hashtag of hastags$ | async; track hashtag) {
            @if (!!hashtag.taggingsCountCommunity) {
              <a
                class="community__additional-info__record"
                [routerLink]="'community' | routeTranslate"
                [queryParams]="{ hashtag: hashtag.name }">
                <div style="border-radius: 50%; padding: 1px; border-color: #4527a0">
                  <img
                    src="https://media.sharry.land/app/images/hashtag.webp"
                    alt="hashtag"
                    height="42"
                    width="42" />
                </div>
                <div>
                  <p class="semibold">{{ hashtag.name }}</p>
                  <small sharryEllipsisTooltip="1">in&nbsp;{{ hashtag.trendingPlace }}</small>
                </div>
              </a>
            }
          }
        </div>
        <div class="community__additional-info">
          <p class="community__additional-info__title semibold bigger">{{ 'community.choosenHastags' | i18next }}</p>
          @for (content of sharrylandPosts$ | async; track content.id) {
            <a
              class="community__additional-info__record"
              [routerLink]="content | slug">
              <div
                [ngStyle]="{
                  'background-image': 'url(' + content.coverPicture?.bestVersion?.url + ')',
                  border: 'none',
                }"></div>
              <div>
                <small
                  class="bold"
                  [innerHTML]="content | colorize: 'short'"></small>
                <p
                  class="semibold"
                  sharryEllipsisTooltip="1">
                  {{ content.title }}
                </p>
              </div>
            </a>
          } @empty {
            <p>{{ 'community.sharrylandPosts.empty' | i18next }}</p>
          }
          <a
            [routerLink]="'community' | routeTranslate"
            [queryParams]="{ hashtag: 'pilloledisharryland' }"
            >{{ 'community.sharrylandPosts.link' | i18next }}
            <sharry-icon
              registryName="caret-right"
              class="svg-icon caret"></sharry-icon>
          </a>
        </div>
      </div>
    </aside>
  </section>
</ng-template>
<sharry-footer class="is-not-mobile"></sharry-footer>
